import i18n from "config/i18next";

i18n.addResources("es", "invoice", {
  invoice: "Factura",
  invoiceData: "Datos de la factura",
  dateOfIssueLabel: "Fecha de emisión *",
  dateOfIssuePlaceholder: "Seleccioná la fecha",
  voucherTypeLabel: "Tipo de comprobante *",
  voucherTypePlaceholder: "Ingresá el comprobante",
  invoiceNumberLabel: "Número de factura *",
  enterNumber: "Ingresá el número",
  generalData: "Datos generales",
  fiscalNumber: "Identificador fiscal",
  businessName: "Razón social",
  typeOfTaxpayer: "Tipo de contribuyente",
  totalToPay: "Total a pagar",
  region: "Región",
  uploadInvoice: "Cargar factura",
  previousInvoice: "Ver factura anterior",
  refuse: "Rechazar factura",
  approve: "Aprobar",
  status: "Estado",
  invoiceNumberError: "Ingresá un número entre 5 y 16 dígitos",
  deleteInvoiceTitle: "Estás por eliminar la factura",
  deleteInvoiceMessage: "¿Realmente querés eliminarla?",
  cancel: "Cancelar",
  delete: "Sí, eliminar",
  invalidFile:
    "El formato del archivo debe ser PDF, PNG o JPG y no puede superar los 5MB",
  serverError:
    "Hubo un error de conexión con el servidor. El nuevo archivo no se subió correctamente.",
  monotributist: "Monotributista",
  fisicalPerson: "Persona física",
  firstCategory: "Primera categoría",
  naturalPerson: "Persona natural",
  modifyData: "Datos a corregir",
  failDataDescription: "Cargá una nueva factura con esta información:\n{{description}}",
  modify: "Corregir",
  manualUpload: "Ingresar manualmente",
  invalidData: "No pudimos validar los datos",
  manualUploadBody: "Deberás ingresarlos manualmente",
  seePicker: "Ver picker",
  missingDataTooltip: `Los datos del picker\n deben estar completos`,
  INCORRECT_IVA: "<b>Condición frente al IVA:</b> {{errorValue}}",
  INCORRECT_INVOICE_TYPE:"<b>Factura:</b> {{errorValue}}",
  INCORRECT_SALE_POINT:"Punto de venta",
  INCORRECT_INVOICE_NUMBER:"Nro de comprobante",
  INCORRECT_CAE:"Nro de CAE",
  INCORRECT_FISCAL_NUMBER: "<b>CUIT del titular:</b> {{errorValue}}",
  INCORRECT_FISCAL_NUMBER_PICKIT:"<b>CUIT de pickit:</b> {{errorValue}}",
  INCORRECT_ISSUE_DATE:"<b>Fecha de emisión:</b> {{errorValue}}",
  INCORRECT_TOTAL_AMOUNT: "<b>Monto:</b> {{errorValue}}",
  INCORRECT_COMPANY_NAME:"<b>Razón social:</b> {{errorValue}}",
  INCORRECT_TAX_RATE:"<b>Impuestos trasladados IVA:</b> {{errorValue}} (una sola vez)",
  INCORRECT_FISCAL_FOLIO:"Folio fiscal",
});

i18n.addResources("es_AR", "invoice", {
  pointOfSaleLabel: "Punto de venta *",
  invoiceNumberLabel: "Número de comprobante *",
  numberCAELabel: "Número de CAE *",
  salePointError: "Ingresá un número de 4 o 5 dígitos",
  invoiceNumberError: "Ingresá un número de 8 dígitos",
  caeNumberError: "Ingresá un número de 14 dígitos",
});

i18n.addResources("es_MX", "invoice", {
  invoiceNumberLabel: "Folio fiscal *",
  invoiceNumberPlaceholder: "Ingresá el folio",
  invoiceNumberError: "Ingresá 36 caracteres sin guiones ni espacios",
  voucherTypeLabel: "Tipo de comprobante",
  INCORRECT_FISCAL_NUMBER: "<b>RFC emisor:</b> {{errorValue}}",
  INCORRECT_FISCAL_NUMBER_PICKIT:"<b>RFC de pickit:</b> {{errorValue}}",
  INCORRECT_TOTAL_AMOUNT: "<b>Subtotal del monto:</b> {{errorValue}}",
});

i18n.addResources("es_CL", "invoice", {
  invoiceNumberLabel: "Número de comprobante *",
  invoiceNumberPlaceholder: "Ingresá el número de comprobante",
  voucherTypeLabel: "Tipo de comprobante",
});
